import { ReactComponent as HighRisk } from './high-risk.svg'
export default HighRisk
